@if (displayAsDropDown()) {
<kendo-label text="Time Period Aggregation">
    <kendo-combobox [data]="displayItems | keyvalue: preserveOrder()"
                    [textField]="'key'"
                    [valueField]="'value'"
                    [valuePrimitive]="true"
                    [disabled]="isDisabled"
                    [(ngModel)]="internalSelectedValue"
                    (blur)="handleBlur()">
    </kendo-combobox>
</kendo-label>
} @else {
<app-single-select-menu [options]="displayItems"
                        [(selectedValue)]="internalSelectedValue">
</app-single-select-menu>
}
